export const readCookies = () => {
    let r = /\s?(.*?)=(.*?);/g
    let c = document.cookie + ';'
    let cookies = {}
    while (true) {
        let m = r.exec(c)
        if (!m) break

        let n = m[1]
        if (!n) continue

        let v = m[2]
        v = v==='null' ? null : v
        cookies[n] = v
    }
    return cookies
}